import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Card, Statistic, Spin, Table } from 'antd';
import {
  DollarOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import PageLayout from '../components/layout/PageLayout';
import PeriodToolbar from '../components/common/PeriodToolbar';
import api from '../libs/api';
import dayjs from 'dayjs';

export default function RetailCrm() {
  const [dateRange, setDateRange] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchData = useCallback(async (range) => {
    if (!range) return;
    setLoading(true);
    try {
      const params = {
        start: range.start,
        end: range.end,
      };
      const res = await api.get('/api/retail-crm/summary', { params });
      setData(res.data.data);
    } catch (error) {
      console.error('Failed to fetch retail CRM data:', error);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchData(dateRange);
  }, [dateRange, fetchData]);

  const columns = [
    {
      title: 'Project No',
      dataIndex: 'projectNo',
      key: 'projectNo',
      width: 150,
    },
    {
      title: 'OC (Quote Number)',
      dataIndex: 'OC',
      key: 'OC',
      width: 150,
    },
    {
      title: 'Commission Date',
      dataIndex: 'commissionDate',
      key: 'commissionDate',
      width: 130,
      render: (date) => date ? dayjs(date).format('YYYY-MM-DD') : '-',
    },
    {
      title: 'CRM GP_max',
      dataIndex: 'gpMax',
      key: 'gpMax',
      align: 'right',
      width: 120,
      render: (val) => val != null ? `$${val.toFixed(2)}` : '-',
      sorter: (a, b) => (a.gpMax || 0) - (b.gpMax || 0),
    },
    {
      title: 'CRM GP_min',
      dataIndex: 'gpMin',
      key: 'gpMin',
      align: 'right',
      width: 120,
      render: (val) => val != null ? `$${val.toFixed(2)}` : '-',
      sorter: (a, b) => (a.gpMin || 0) - (b.gpMin || 0),
    },
  ];

  const metrics = data?.metrics || {};
  const gpData = data?.gpData || [];

  return (
    <PageLayout>
      <div className="page-header">
        <h1>SH Residential (Retail CRM)</h1>
        <p>Customer and GP data from MongoDB (shinehub database)</p>
      </div>
      <PeriodToolbar onChange={setDateRange} />
      <Spin spinning={loading}>
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic
                title="Project Count"
                value={metrics.projectCount || 0}
                prefix={<FileTextOutlined />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic
                title="Total GP_max"
                value={metrics.totalGpMax || 0}
                precision={2}
                prefix={<DollarOutlined />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic
                title="Total GP_min"
                value={metrics.totalGpMin || 0}
                precision={2}
                prefix={<DollarOutlined />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card>
              <Statistic
                title="Avg GP_max"
                value={metrics.avgGpMax || 0}
                precision={2}
                prefix={<DollarOutlined />}
              />
            </Card>
          </Col>
        </Row>

        <Card title="GP Breakdown by Project" style={{ marginTop: 16 }}>
          <Table
            columns={columns}
            dataSource={gpData}
            rowKey={(record) => record.projectId || record.OC}
            pagination={{
              pageSize: 20,
              showSizeChanger: true,
              showTotal: (total) => `${total} projects`,
            }}
            scroll={{ x: 800 }}
          />
        </Card>
      </Spin>
    </PageLayout>
  );
}
